import { CognitoUser } from 'amazon-cognito-identity-js';
import { useReducer, Dispatch } from 'react';
import { ActionType, ActionMap } from './baseTypes';

enum DispatchTypes {
  SET_COGNITO_USER = 'SET_COGNITO_USER',
  SET_USERNAME = 'SET_USERNAME',
  SET_PASSWORD = 'SET_PASSWORD',
}

type UserActionType = ActionType<DispatchTypes>;

export type UserDispatch = Dispatch<UserActionType>;

export type User = {
  cognitoUser: CognitoUser | null;
  username: string;
  password: string;
};

const actions = {
  [DispatchTypes.SET_COGNITO_USER]: (state: User, cognitoUser?: CognitoUser) => ({
    ...state,
    cognitoUser,
  }),
  [DispatchTypes.SET_USERNAME]: (state: User, username?: string) => ({ ...state, username }),
  [DispatchTypes.SET_PASSWORD]: (state: User, password?: string) => ({ ...state, password }),
} as ActionMap<User>;

export const userActions = {
  setCognitoUser: (user?: CognitoUser) => (dispatch: UserDispatch): void => {
    dispatch({ type: DispatchTypes.SET_COGNITO_USER, payload: user });
  },
  setUsername: (username?: string) => (dispatch: UserDispatch): void => {
    dispatch({ type: DispatchTypes.SET_USERNAME, payload: username });
  },
  setUserCreds: (username?: string, password?: string) => (dispatch: UserDispatch): void => {
    dispatch({ type: DispatchTypes.SET_USERNAME, payload: username });
    dispatch({ type: DispatchTypes.SET_PASSWORD, payload: password });
  },
};

const reducer = (state: User, { type, payload }: UserActionType) => actions[type]?.(state, payload) || state || null;

const initState: User = {
  cognitoUser: null,
  username: '',
  password: '',
};

export const useUserReducer = (): [User, UserDispatch] => useReducer(reducer, initState);
